import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  // CSRF defence — the backend enforces `X-Requested-With: XMLHttpRequest`
  // on every state-changing /api call. Browsers refuse to send custom
  // headers on <form> submissions / <img> / <script> tags, so an attacker
  // origin can't spoof this even when SameSite=none cookies attach.
  headers: { "X-Requested-With": "XMLHttpRequest" },
});

// Cookie-only auth — httpOnly access_token + refresh_token are set by the
// backend on /auth/login and travel automatically with `withCredentials`.
// We deliberately do NOT mirror the token into localStorage to avoid an
// XSS exfiltration path. For file downloads via <a href> or window.open
// (which can't attach an Authorization header), the same cookies are
// included automatically since requests are same-origin.

export function formatApiError(detail, fallback = "Something went wrong") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
